import { findKey, includes } from 'lodash';

import {
  TEXT_WITHOUT_SLASH,
  YEAR_SLASH_MONTH_OPTIONAL_SLASH_DAY,
} from '@wix/communities-blog-universal/dist/src/constants/regexp';

export const PAGE_NOT_FOUND = 'page_not_found';
export const USER_SETTINGS = 'user_settings';
export const USER_PROFILE = 'user_profile';
export const USER_EDIT_PROFILE = 'user_edit_profile'; // no route
export const NOTIFICATIONS = 'notifications';
export const SEARCH_RESULTS = 'search_results';
export const POST_PAGE = 'post_page';
export const POST_PAGE_PREVIEW = 'post_page_preview';
export const POST_EDIT_PAGE = 'post_edit_page';
export const COMMENT_EDIT_PAGE = 'comment_edit_page';
export const FEED_PAGE = 'feed_page';
export const CATEGORY_PAGE = 'categories_page';
export const CREATE_POST = 'create_post';
export const MEMBERS_PAGE = 'members_page';

const MATCH_POST_PAGE = `(${YEAR_SLASH_MONTH_OPTIONAL_SLASH_DAY}/)?${TEXT_WITHOUT_SLASH}`;

export const REGEX_POST_PAGE_PREVIEW = /[0-9a-fA-F]+\/preview\/([^/]+)\/?/;

export const routeMap = {
  [PAGE_NOT_FOUND]: /^\/404\/?$/,
  [FEED_PAGE]: /^\/(page\/[1-9]\d*\/?)?$/,
  [USER_SETTINGS]: /^\/profiles\/.*?\/settings/,
  [USER_PROFILE]: /^\/profiles\/[0-9a-zA-Z-_]+\/?$/,
  [NOTIFICATIONS]: /^\/notifications\/?$/,
  [MEMBERS_PAGE]: /^\/members\/?$/,
  [SEARCH_RESULTS]: /^\/search\/?/,
  [CREATE_POST]: /^\/create-post\/?/,
  [CATEGORY_PAGE]: /^\/categor(ies|y)\/[^/]+(\/[^/]+)?(\/page\/[1-9]\d*)?\/?$/,
  [COMMENT_EDIT_PAGE]: new RegExp(`^/${MATCH_POST_PAGE}/edit-comment/[0-9a-zA-Z-_]+/?`),
  [POST_EDIT_PAGE]: new RegExp(`^/${MATCH_POST_PAGE}/edit/?`),
  [POST_PAGE_PREVIEW]: REGEX_POST_PAGE_PREVIEW,
  [POST_PAGE]: new RegExp(`^/${MATCH_POST_PAGE}/?`),
};

const testRoute = (map, location) => findKey(routeMap, regex => regex.test(location));

const detectRoute = location => {
  const pathname = typeof location === 'object' ? location.pathname : location;
  return pathname && testRoute(routeMap, pathname);
};

export const isInFeed = location => detectRoute(location) === FEED_PAGE;
export const isInCategory = location => detectRoute(location) === CATEGORY_PAGE;
export const isInFeedOrCategory = location => includes([CATEGORY_PAGE, FEED_PAGE], detectRoute(location));
export const isInPostPage = location => detectRoute(location) === POST_PAGE;
export const isInPostPreview = location => detectRoute(location) === POST_PAGE_PREVIEW;
export const isInCreatePostPage = location => detectRoute(location) === CREATE_POST;
export const isInPostEditor = location => includes([CREATE_POST, POST_EDIT_PAGE], detectRoute(location));
export const isInSearchPage = location => detectRoute(location) === SEARCH_RESULTS;

export const isSameLocation = (previous, current) => !current || !previous || current.pathname === previous.pathname;

export default detectRoute;
